import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '../../product.service';

@Component({
  selector: 'pv-notify-email',
  templateUrl: './notify-email.component.html',
  styleUrls: ['./notify-email.component.scss']
})
export class NotifyEmailComponent implements OnInit {
  @Input() label: string
  @Input() instanceId: number
  email: string;
  message: string;
  loading: boolean = false;
  finished: boolean = false;

  constructor(private productService: ProductService) { }

  ngOnInit() { }

  saveEmail() {
    if (!this.email || this.email.length < 4) {
      return;
    }
    this.loading = true;
    this.productService.addNotificationEmail(this.email, this.instanceId)
    .subscribe(data => {
      this.message = `Thanks!  We'll let you know when this item is available.`
      this.loading = false;
      this.finished = true;
    }, error => {
      this.message = 'Didn\'t work'
      this.loading = false;
    })
  }
}
